import { render } from "./PartnerDetails.vue?vue&type=template&id=3524ca18&scoped=true&ts=true"
import script from "./PartnerDetails.vue?vue&type=script&lang=ts"
export * from "./PartnerDetails.vue?vue&type=script&lang=ts"

import "./PartnerDetails.vue?vue&type=style&index=0&id=3524ca18&scoped=true&lang=sass"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3524ca18"]])

export default __exports__